import * as React from 'react';
import { FunctionComponent, useContext } from 'react';

// MUI
import Stack from "@mui/material/Stack";
import Box from '@mui/material/Box';

// Custom components
import SidebarHeading from './SidebarHeading';
import SidebarContext, { SidebarContextType } from './SidebarContext/SidebarContext';
import { Permission } from '@/@types/common';
import UserContext from '@/components/UserContext/UserContext';

// Types
export interface ISidebarPane {
  id: string;
  children: JSX.Element | JSX.Element[];
  needPermission?: Permission[];
  noPadding?: boolean; // To have more control over styling individual panes
  limitHeight?: boolean; // To disable default scrollbar over sidebar pane, useful when we want a child to be scrollable instead
}

const SidebarPane: FunctionComponent<ISidebarPane> = (
  props: React.PropsWithChildren<ISidebarPane>
) => {
  const sidebarContext = useContext(SidebarContext) as SidebarContextType;

  const { id, children, needPermission, noPadding, limitHeight } = props;

  const userContext = useContext(UserContext);

  const isActive = sidebarContext.activePane === id;

  const hasPermission = needPermission === undefined || userContext?.hasAnyPermission(needPermission);

  return isActive && hasPermission ? (
    <Box m={0} sx={{height: "100%", overflowY: "auto"}}>
      <Box m={0}
        id={id}
        sx={{
          display: "block",
          left: 0,
          right: 0,
          height: "100%",
          boxSizing: "border-box",
          maxHeight: limitHeight ? "100%" : undefined,
          padding: noPadding ? undefined : "10px 20px",
          width: "100%"
        }}
      >
        {children}
      </Box>
    </Box>
  ) : null;
};

export default SidebarPane;
